/**
 * Pdf portal
 * Portal to generate PDF and handle authentication.
 *
 * OpenAPI spec version: 1.0.32
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { Category } from './category';
import { Explanation } from './explanation';
import { Legend } from './legend';
import { Tip } from './tip';

/**
 * Base class serializer for all OpenAPI serializers.  It only implements create/update method without any logic to prevent \"abstract\" warning by pylint.
 */
export interface EduActivity { 
    category: Category;
    evaluation: Legend;
    explanation: Explanation;
    tips: Array<Tip>;
    elseTipCount: number;
    worksheetCount: number;
    videoCount: number;
}